import type { SessionStepModule } from '../types';
import { PanFormContent } from './PanFormContent';
import { PanStepRunner } from './PanStepRunner';
import { isPanStep } from './pan.utils';

// PAN Verification step module (APIs: PAN Verification / PAN Lite / PAN OCR).
export const panStepModule: SessionStepModule = {
  key: 'pan',
  matches: isPanStep,
  Runner: PanStepRunner,
  Detail: PanFormContent,
};
